import { apiJson } from './apiFetch';

export type AccountFeature =
  | 'newsfeed'
  | 'academy'
  | 'briefings'
  | 'tasks'
  | 'recordings'
  | 'calendar'
  | 'checklists'
  | 'handovers'
  | 'shiftFill'
  | 'mustReads';

// Features an account only gets once a superadmin switches them on in KIT (mirrors khova-api).
const OPT_IN_FEATURES: readonly AccountFeature[] = ['calendar', 'checklists', 'handovers', 'shiftFill', 'mustReads'];

export interface AccountBranding {
  primaryColor: string | null;
  logoUrl: string | null;
}

export interface AccountConfig {
  features: Partial<Record<AccountFeature, boolean>> & Record<string, boolean>;
  branding: AccountBranding;
}

export const ACCOUNT_CONFIG_QUERY_KEY = ['account-config'] as const;

export const getAccountConfig = (): Promise<AccountConfig> => apiJson<AccountConfig>('/accounts/current/config');

/** A feature missing from the map is enabled (contract §7), except the opt-in ones. */
export const isFeatureEnabled = (features: AccountConfig['features'] | undefined, feature: AccountFeature): boolean =>
  features?.[feature] ?? !OPT_IN_FEATURES.includes(feature);
